import api from '@/services/api'
import ClassificationActions from './actions-types'

export default {
  [ClassificationActions.GET_CLASSIFICATION_BY_NODE]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.node.classification
        .getClassificationByNode(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [ClassificationActions.GET_CLASSIFICATION_RECURSIVE_BY_NODE]({}, nodeId) {
    return new Promise((resolve, reject) => {
      api.node.classification
        .getClassificationRecursiveByNode(nodeId)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [ClassificationActions.SIMULATE_MARKS_PERMISSION]({}, params) {
    return new Promise((resolve, reject) => {
      api.node.classification
        .simulateMarksPermission(params)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    })
  },

  [ClassificationActions.SAVE_SECURITY_CLASSIFICATION]({}, classification) {
    return new Promise((resolve, reject) => {
      api.node.classification
        .saveSecurityClassification(classification)
        .then(() => {
          resolve()
        })
        .catch(() => reject())
    })
  },

  [ClassificationActions.SAVE_SECURITY_CLASSIFICATION_PER_NODE]({}, classification) {
    // Accept shapes:
    // - { nodeId, marks: number[] }
    // - [{ nodeId, marks }...]
    // - { node_id, security_marks }
    // - [{ node_id, security_marks }...]
    const items = Array.isArray(classification) ? classification : [classification]
    const calls = []
    items.forEach(it => {
      const nodeId = it.nodeId ?? it.node_id
      const marks = Array.isArray(it.marks) ? it.marks : (Array.isArray(it.security_marks) ? it.security_marks : [])
      marks.forEach(mark => calls.push(api.node.classification.addNodeClassification(nodeId, mark)))
    })
    return Promise.all(calls).then(() => {})
  },

  [ClassificationActions.CLEAR_SECURITY_CLASSIFICATION_PER_NODE]({}, payload) {
    // Accept shapes:
    // - { nodeId, marks: number[] }
    // - [{ nodeId, marks }...]
    // - { node_id, security_marks }
    // - [{ node_id, security_marks }...]
    // - Fallback: { nodeId, security_group_id } -> remove all marks from the group
    const items = Array.isArray(payload) ? payload : [payload]
    const calls = []
    items.forEach(it => {
      const nodeId = it.nodeId ?? it.node_id
      const marks = Array.isArray(it.marks) ? it.marks : (Array.isArray(it.security_marks) ? it.security_marks : [])
      if (marks.length) {
        marks.forEach(mark => calls.push(api.node.classification.removeNodeClassification(nodeId, mark)))
      } else if (it.security_group_id) {
        const node_id = nodeId
        const security_group_id = it.security_group_id
        calls.push(api.node.classification.deleteNodeClassification({ node_id, security_group_id }))
      }
    })
    return Promise.all(calls).then(() => {})
  }
}
